module.exports = __webpack_public_path__ + "static/media/iconMemorialP.c9322d9e.svg";